var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('header',[_c('Menu')],1),_vm._v(" "),_c('Nuxt'),_vm._v(" "),_c('CookieAgreementPopup')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }